/* eslint-disable import/prefer-default-export */
import type { IApiRouteResponse } from 'types/common';
import type { TWishlist, TWishlistProductPayload } from 'types/wishlist';

interface IResponse extends IApiRouteResponse {
  data: TWishlist;
}

export const fetchRemoveProductFromWishlist = async ({
  wishlistId,
  productId,
}: TWishlistProductPayload): Promise<IResponse> => {
  const response = await fetch('/api/wishlist/remove-product', {
    method: 'DELETE',
    body: JSON.stringify({
      wishlistId,
      productId,
    }),
  });

  return response.json();
};
